import React, { Component } from 'react';
import CollectionSidebarElement from './CollectionSidebarElement'
import getCollectionItems from '../../services/collectionsService'
import CollectionItems from './CollectionItems'
import Loader from "react-loader-spinner";

class CollectionSidebar extends Component {
   state = {
       collectionItems:{},
       loadingData:true,
       searchItems: [],
       loadingCollections:false
   }
   fetchCollections = async (id) =>{
       this.setState({loadingCollections:true})
       let response = await getCollectionItems.fetchCollection(id)
       let items  = await response.data
       this.setState({
           collectionItems:items,
           loadingData:false,
           searchItems : items.items,
           loadingCollections:false
    })

   }

   search = (event) => {
       const value  = []
       this.state.collectionItems.items.filter((item) =>{
           console.log(item)
            if(item.title && item.title.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }else if(item.date && item.date.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }else if(item.plate_number && item.plate_number.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }else if(item.supplier && item.supplier.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }
       })

       this.setState ({searchItems : value})
   }

   personalSearch = (event) => {
        const value  = []
        this.state.collectionItems.items.filter((item) =>{
            if(item.names && item.names.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }else if(item.location && item.location.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }else if(item.position && item.position.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }else if(item.staff_id && item.staff_id.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }else if(item.status && item.status.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }else if(item.date_of_joining && item.date_of_joining.toLowerCase().includes(event.target.value.toLowerCase())) {
                value.push(item)
            }
        })
        this.setState ({searchItems : value})
   }
    render() {
        let { collections ,isLoading ,departmentId } = this.props
        let {collectionItems , loadingData, searchItems} = this.state
        return (
        <div className="">
            <div className="py-3 px-8 w-full rounded-md bg-white">
                <div className ="">
                    <span className="font-bold">Collections</span>
                </div>
                <div className="text-sm flex">
                    {
                        isLoading &&
                        <div className="my-4 mx-4">
                            <Loader
                            type="Puff"
                            color="#F35D2D"
                            height={50}
                            width={50} />
                        </div>

                    }
                    <div className ="grid grid-cols-6">
                   {
                     collections.length > 0 ?
                     collections.map(element=>
                        <CollectionSidebarElement
                        key={element.id}
                        id={element.id}
                        title={element.title}
                        numberOfFiles={element.items_count}
                        fetchCollections = {this.fetchCollections}
                    />
                )
                     :
                     <div className='px-8 flex'>
                         <span className='text-red-600 font-bold'>No Collections</span>
                     </div>    
                   }
                    </div>
                </div>
            </div>
                <div className="p-2 w-full">
                   <CollectionItems
                    personalSearch = {this.personalSearch}
                    searchValue = {this.search}
                    departmentId = {departmentId}
                    items = {searchItems}
                    collectionItems = {collectionItems}
                    loadingCollections = {this.state.loadingCollections}
                    loadingData = {loadingData} />
                    
                </div>

        </div>
         );
    }
}

export default CollectionSidebar;
